export const BOOKING_ITEM_TYPE_ITEM = "item";
export const BOOKING_ITEM_TYPE_SERVICE = "service";
export const BOOKING_ITEM_TYPE_LOGISTICS = "logistics";
// AI-captured out-of-catalogue scope (#100): seeded with a NULL hire_rate.
// The server blocks send-to-client while one is unpriced.
export const BOOKING_ITEM_TYPE_SCOPE = "scope";

/** True for a scope row the operator has not priced yet (#100). */
export function isUnpricedScopeItem(item: {
  type?: string | null;
  hire_rate?: number | null;
}): boolean {
  return (
    normalizeBookingItemType(item.type) === BOOKING_ITEM_TYPE_SCOPE &&
    item.hire_rate == null
  );
}

export function normalizeBookingItemType(type?: string | null): string {
  const raw = (type ?? "").trim().toLowerCase();
  if (!raw || raw === "gear") return BOOKING_ITEM_TYPE_ITEM;
  if (raw === "labour" || raw === "tech" || raw === "tech_time") {
    return BOOKING_ITEM_TYPE_SERVICE;
  }
  if (raw === "transport" || raw === "vehicle") {
    return BOOKING_ITEM_TYPE_LOGISTICS;
  }
  return raw;
}

/**
 * True when a row's quantity already carries its whole duration, so pricing
 * must not multiply by the hire window again — service and scope.
 *
 * A service row holds TOTAL hours (12 setup hours, not 4 × 3 days). Scope rows
 * are drafted the same way — the AI writes 42 for 14 hours a day across 3
 * event days — but inherit the Booking's window, so they billed the duration
 * twice. Their Days cell renders as a dash. Mirrors bookingitem.IsSingleDay.
 */
export function isSingleDayItem(type?: string | null): boolean {
  const t = normalizeBookingItemType(type);
  return t === BOOKING_ITEM_TYPE_SERVICE || t === BOOKING_ITEM_TYPE_SCOPE;
}

export function isAvailabilityControlledItem(type?: string | null): boolean {
  return normalizeBookingItemType(type) === BOOKING_ITEM_TYPE_ITEM;
}
